export default class Client {
  constructor(apikey, secret, passphrase, user) {
    this.apiKey = apikey;
    this.secret = secret;
    this.passphrase = passphrase;
    this.user = user;

  }
}
